import auth from './auth';
import loader from './loader';
import members from './members';
import newsletter from './newsletter';
import press from './press';
import snackbar from './snackbar';
import files from './files';
import ui from './ui';
import rules from './rules';
import ads from './ads';
import articles from './articles';
import events from './events';
import campaigns from './campaigns';
import campaignArticles from './campaignArticles';
import version from './version';

export default {
  ads,
  auth,
  articles,
  campaigns,
  campaignArticles,
  events,
  loader,
  files,
  members,
  newsletter,
  press,
  snackbar,
  ui,
  rules,
  version,
};
